/**
 * RegExp for getting stop-color value out of css string
 * @type {String}
 */
const STOP_COLOR_RGX = /stop-color:\s*([^;]+);?/;

const STOP_COLOR_ATTRIBUTES = {
    STOP_COLOR: 'stop-color',
    OFFSET: 'offset',
    STYLE: 'style'
};

const GRADIENTS_ATTRIBUTES = {
    XLINK_HREF: 'xlink:href'
};

module.exports = {
    STOP_COLOR_RGX,
    STOP_COLOR_ATTRIBUTES,
    GRADIENTS_ATTRIBUTES
};
